import type { DataTypes } from 'fitify-ui-landing/src/@types'

const reviewsData: DataTypes.ReviewItem[] = [
  {
    name: 'cl_landing_review_name_1',
    description: 'cl_landing_review_text_1',
  },
  {
    name: 'cl_landing_review_name_2',
    description: 'cl_landing_review_text_2',
  },
  {
    name: 'cl_landing_review_name_3',
    description: 'cl_landing_review_text_3',
  },
]

const reviewCommunityData: {
  imageSrc: string
  imageSrcSet: string
  alt: string
} = {
  imageSrc: '/assets/images/avatars/avatars@2x.webp',
  imageSrcSet:
    '/assets/images/avatars/avatars.webp 600w, /assets/images/avatars/avatars@2x.webp 2x, /assets/images/avatars/avatars@2x.webp 1200w',
  alt: 'Community user avatars',
}

export { reviewsData, reviewCommunityData }
